var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6C4.44772 6 4 6.44772 4 7V8.44575C4 8.79054 4.17762 9.11101 4.47 9.29375L11.47 13.6688C11.7943 13.8714 12.2057 13.8714 12.53 13.6688L19.53 9.29375C19.8224 9.11101 20 8.79054 20 8.44575V7C20 6.44772 19.5523 6 19 6H5ZM4.3825 10.2391C4.21599 10.135 4 10.2547 4 10.4511V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V10.4511C20 10.2547 19.784 10.135 19.6175 10.2391L12.53 14.6688C12.2057 14.8714 11.7943 14.8714 11.47 14.6688L4.3825 10.2391Z",
    fill: "#E0E1EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailNew);
export default __webpack_public_path__ + "static/media/email-new.f81c5598.svg";
export { ForwardRef as ReactComponent };